import { Directive, Input, OnChanges, inject } from '@angular/core';
import { AbstractControl, ControlContainer } from '@angular/forms';

@Directive({
	selector: '[svgFrontendsDisableForm]',
	standalone: false,
})
export class MacDisableFormDirective implements OnChanges {
	private controlContainer = inject(ControlContainer);

	@Input() svgFrontendsDisableForm: boolean | undefined;

	/**
	 * [NOTE] svgFrontendsDisableForm condition is not enough to decide whether the control should be disabled or enabled.
	 * 				the third option `do nothing` is needed too.
	 */
	ngOnChanges(): void {
		const abstractControl: AbstractControl = this.controlContainer.control;

		if (this.svgFrontendsDisableForm !== undefined) {
			if (this.svgFrontendsDisableForm) {
				abstractControl.disable({ emitEvent: false });
			} else if (!this.svgFrontendsDisableForm) {
				abstractControl.enable({ emitEvent: false });
			}
		}
	}
}
